import googleAds  from './googleAds'


export default {
  googleAds,

}